import styles from "@shared/components/chat/Messages.module.scss"

import React, { memo } from "react"

import { ChatDownIcon, PowerfulMessage } from "@shared/components"
import {
  useLayerPopupContext,
  useMessagesContext,
  useSchedule,
} from "@shared/contexts"
import { useMessagesRef } from "@shared/hooks"

import classNames from "classnames"

import { useAiIssueCatchStore } from "../../../../@shared/stores/sidebarStore"

interface Props {
  isActive: boolean
}

export default memo(function ManagerMessages({ isActive }: Props) {
  const { font } = useLayerPopupContext()
  const { managerMessages: messages } = useMessagesContext()
  const { isOpen } = useAiIssueCatchStore()
  const { schedule } = useSchedule()
  const isFree = schedule?.paymentInformation !== "PAID"

  const { messagesRef, handleScroll: scrollMessages } = useMessagesRef({
    messages,
  })

  const chatBoxStyle = {
    height: isFree ? "100%" : `calc(100% - ${isOpen ? 238 : 130}px)`,
  }

  return (
    <div
      className={classNames(
        "chatB",
        [isActive ? styles.active : styles.hidden],
        styles.activePadding,
      )}
      style={chatBoxStyle}
    >
      <div className={classNames("inner", styles[font.size])} ref={messagesRef}>
        {messages.map((message) => (
          <PowerfulMessage
            key={message.key}
            message={message}
            scrollMessages={scrollMessages}
          />
        ))}
        <ChatDownIcon messagesRef={messagesRef} />
      </div>
    </div>
  )
})
